import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import "./OutletSideMenu.css";
import DataContext from "../../utils/Context/DataContext";

const menu_initial_value = [
  {
    id: 1,
    name: "DASHBOARD",
    path: "dashboard",
    img: require("../../assets/icon/svg/grid.svg"),
  },

  // {
  //   id: 2,
  //   name: "ORDERS",
  //   path: "order/all",
  //   img: require("../../assets/icon/svg/bookmark.svg"),
  // },
  {
    id: 3,
    name: "CUSTOMERS",
    path: "company",
    img: require("../../assets/icon/svg/monitor.svg"),
  },
  {
    id: 3,
    name: "ASSIGN SERVICES",
    path: "assign",
    img: require("../../assets/icon/svg/send.svg"),
  },

  {
    id: 4,
    name: "USERS",
    path: "user",
    img: require("../../assets/icon/svg/users.svg"),
  },
  // {
  //   id: 5,
  //   name: "TASKS",
  //   path: "task",
  //   img: require("../../assets/icon/svg/alert-octagon.svg"),
  // },
  {
    id: 6,
    name: "EDITORS",
    path: "editors",
    img: require("../../assets/icon/svg/pen-tool1.svg"),
  },
  {
    id: 7,
    name: "ORDERS REQUEST",
    path: "order_request/all",
    img: require("../../assets/icon/svg/folder-plus.svg"),
  },
  {
    id: 8,
    name: "COMPLETED TASK",
    path: "completed_task",
    img: require("../../assets/icon/svg/check-circle.svg"),
  },

  {
    id: 9,
    name: "SETTINGS",
    path: "settings",
    img: require("../../assets/icon/svg/settings.svg"),
    is_open: false,
    children: [
      {
        id: 1,
        name: "SERVICES",
        path: "service",
        img: require("../../assets/icon/svg/pie-chart.svg"),
      },
      // {
      //   id: 2,
      //   name: "EVENTS",
      //   path: "event",
      //   img: require("../../assets/icon/svg/calendar.svg"),
      // },
      // {
      //   id: 3,
      //   name: "COMPANY",
      //   path: "company",
      //   img: require("../../assets/icon/svg/monitor.svg"),
      // },
      {
        id: 4,
        name: "PROFILE",
        path: "profile",
        img: require("../../assets/icon/svg/user.svg"),
      },
    ],
  },
  // {
  //   id: 10,
  //   name: "SAMPLE DROPDOWN",
  //   is_open: false,
  //   children: [
  //     {
  //       id: 6.1,
  //       name: "DROPDOWN1",
  //       path: "dp1",
  //     },
  //     {
  //       id: 6.2,
  //       name: "DROPDOWN2",
  //       path: "dp2",
  //     },
  //   ],
  // },
];

export default function OutletSideMenu(props) {
  const context = useContext(DataContext);

  const [is_active, SetIsActive] = useState(props.active);
  const [menu_items, SetMenuItems] = useState(menu_initial_value);
  const [user_data, SetUserData] = useState({});
  const [id_value, SerIdValue] = useState(useParams());
  const [view_data, SetViewData] = useState({});

  useEffect(() => {
    console.log("OutletSideMenu On mount :", props);
    console.log("OutletSideMenu On mount context :", context);
    console.log("AdminSideMenu On mount id_value :", id_value);

    // SetUserData(context.app_data.user_data);
    let user_value = localStorage.getItem("user_data");
    console.log("user_value :", JSON.parse(user_value));
    SetUserData(JSON.parse(user_value));
    // let view_value = localStorage.getItem("view_data");
    // SetViewData(JSON.parse(view_value));

    // let view_data_value = context.app_data.active_account_data;
    // let view_data_value = props.view_data_value;

    // SetViewData(view_data_value);
  }, []);

  useEffect(() => {
    console.log("OutletSideMenu On props.active :", props);
    SetIsActive(props.active);
  }, [props.active]);

  useEffect(() => {
    if (Object.keys(props.view_data_value).length > 0) {
      SetViewData(props.view_data_value);
    }
  }, [props.view_data_value]);

  function dropdown_action(m_item, m_index) {
    let items = menu_items;
    items[m_index].is_open = !m_item.is_open;
    SetMenuItems([...items]);
  }

  function dropdown_close() {
    let items = menu_items;
    items.map((item) => {
      if (item.hasOwnProperty("is_open")) {
        item.is_open = false;
      }
    });
    SetMenuItems([...items]);
  }

  return (
    <div>
      <div className="overlay"></div>

      <div className={is_active ? "sidebar active" : "sidebar"}>
        <div className="d-lg-none d-flex align-items-center">
          {/* <i className="fas fa-arrow-left px-3 py-2 text-white"></i> */}
          <div
            className="cursor"
            onClick={() => {
              props.menu_click(false);
            }}
          >
            <img src={require("../../assets/icon/svg/x.svg")} className="p-1" />
          </div>
          <Link to="/" className="ms-auto cursor">
            <img
              src={require("../../assets/icon/svg/log-out.svg")}
              className="p-2"
            />
          </Link>
        </div>
        {/* <div className="mb-3 text-center d-lg-block d-md-none">
          <svg className="svg-align">
            <path
              className="st0"
              d="M43.8,22H36c-0.2,0-0.4,0.1-0.5,0.3l-1.4,3.3c-0.1,0.2-0.3,0.3-0.5,0.3h-2.1c-0.3,0-0.5-0.2-0.5-0.5  c0-0.1,0-0.1,0-0.2l7.1-15.9C38.2,9.1,38.4,9,38.6,9H41c0.2,0,0.4,0.1,0.5,0.3l7.2,15.9c0.1,0.3,0,0.6-0.3,0.7c-0.1,0-0.1,0-0.2,0  H46c-0.2,0-0.4-0.1-0.5-0.3l-1.4-3.3C44.2,22.1,44,22,43.8,22z M42.8,18.8l-2.4-5.6C40.3,13,40,12.9,39.7,13  c-0.1,0.1-0.2,0.1-0.3,0.3L37,18.9c-0.1,0.3,0,0.5,0.3,0.7c0.1,0,0.1,0,0.2,0h4.8c0.3,0,0.5-0.2,0.5-0.5  C42.8,19,42.8,18.9,42.8,18.8L42.8,18.8z"
            />
            <path
              className="st0"
              d="M52.2,25.3c-1-0.5-1.9-1.3-2.5-2.4c-1.2-2.1-1.2-4.7,0-6.8c0.6-1,1.5-1.8,2.5-2.3c1.1-0.6,2.4-0.9,3.6-0.8  c1.2,0,2.3,0.2,3.3,0.8c0.8,0.4,1.4,1,1.9,1.8c0.2,0.2,0.1,0.5-0.1,0.7l0,0L59.4,17c-0.2,0.1-0.5,0.1-0.7-0.1  c-0.3-0.4-0.7-0.8-1.1-1c-0.6-0.3-1.2-0.4-1.8-0.4c-1,0-2.1,0.4-2.8,1.1c-0.8,0.8-1.2,1.8-1.1,2.9c-0.1,1.1,0.4,2.2,1.1,3  c1.2,1.2,3.1,1.5,4.6,0.6c0.4-0.2,0.8-0.6,1.1-1c0.2-0.2,0.4-0.3,0.7-0.1l1.5,0.9c0.2,0.1,0.3,0.4,0.2,0.7l0,0  c-0.5,0.7-1.1,1.4-1.9,1.8c-1,0.5-2.2,0.8-3.3,0.8C54.6,26.1,53.3,25.8,52.2,25.3z"
            />
            <path
              className="st0"
              d="M65,25.3c-1-0.5-1.9-1.4-2.5-2.4s-0.9-2.2-0.9-3.4c0-1.2,0.3-2.4,0.9-3.4c0.6-1,1.4-1.8,2.5-2.3  c1.1-0.6,2.3-0.9,3.5-0.8c1.2,0,2.5,0.3,3.6,0.8c1,0.5,1.9,1.4,2.4,2.3c1.2,2.1,1.2,4.7,0,6.8c-0.6,1-1.4,1.8-2.4,2.4  c-1.1,0.6-2.3,0.9-3.6,0.9C67.3,26.1,66.1,25.8,65,25.3z M71.3,22.4c0.7-0.8,1.1-1.8,1.1-2.9s-0.3-2.1-1.1-2.9c-1.5-1.5-4-1.5-5.5,0  c-0.7,0.8-1.1,1.8-1.1,2.9s0.3,2.1,1.1,2.9C67.3,23.9,69.7,23.9,71.3,22.4z"
            />
            <path
              className="st0"
              d="M84.8,13.4v1.8c0,0.3-0.2,0.5-0.5,0.5l0,0h-0.2c-1-0.1-2,0.3-2.8,1c-0.7,0.8-1.1,1.9-1,3v5.7  c0,0.3-0.2,0.5-0.5,0.5l0,0h-2c-0.3,0-0.5-0.2-0.5-0.5l0,0V13.6c0-0.3,0.2-0.5,0.5-0.5h1.9c0.3,0,0.5,0.2,0.5,0.5l0,0v0.1  c0,0.3,0.2,0.5,0.5,0.5c0.1,0,0.2,0,0.3-0.1c0.9-0.7,2.1-1.1,3.2-1.1C84.5,12.9,84.8,13.1,84.8,13.4L84.8,13.4z"
            />
            <path
              className="st0"
              d="M97.6,14.3c1.1,1.1,1.6,2.7,1.5,4.2v6.9c0,0.3-0.2,0.5-0.5,0.5l0,0h-2c-0.3,0-0.5-0.2-0.5-0.5l0,0v-6.5  c0.1-0.9-0.2-1.8-0.8-2.5c-0.6-0.6-1.4-0.9-2.3-0.9c-1-0.1-1.9,0.3-2.6,1c-0.7,0.8-1.1,1.8-1,2.9v6c0,0.3-0.2,0.5-0.5,0.5l0,0h-2  c-0.3,0-0.5-0.2-0.5-0.5l0,0V13.6c0-0.3,0.2-0.5,0.5-0.5l0,0h1.9c0.3,0,0.5,0.2,0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5  c0.1,0,0.2,0,0.3-0.1c0.3-0.2,0.7-0.4,1.1-0.6c0.8-0.3,1.7-0.5,2.6-0.5C95.1,12.8,96.5,13.3,97.6,14.3z"
            />
            <path
              className="st0"
              d="M23.7,7.2c-1.7-1.2-4.5-2.6-8.8-2.9V4c0-0.1,0.1-0.2,0.2-0.2l0.5-0.1c0.9-0.2,1.5-1.2,1.3-2.1  c-0.2-0.9-1.2-1.5-2.1-1.3l-0.5,0.1c-1.7,0.4-2.8,1.9-2.8,3.6v0.3C7,4.5,4.2,5.9,2.5,7.2c-1.4,1-2.2,2.9-2,4.9l0.2,1.8  c0.1,1.3,0.7,2.5,1.7,3.5l0.6,6.4c0.2,2.6,1.6,4.9,3.8,6.4l1.9,1.3c1.3,0.9,2.9,1.4,4.4,1.4c1.5,0,3.1-0.5,4.4-1.4l1.9-1.3  c2.2-1.5,3.5-3.8,3.8-6.4l0.6-6.4c1-1,1.5-2.2,1.7-3.5l0.2-1.8C25.8,10,25.1,8.2,23.7,7.2z M4.6,10c1.5-1.1,4.1-2.3,8.5-2.3  c4.4,0,7,1.3,8.5,2.3c0.6,0.4,0.6,1.3,0.5,1.7l-0.2,1.8c-0.1,0.7-0.4,1.3-1,1.7c-0.7,0.5-1.6,0.7-2.5,0.5c-1.9-0.4-3.7-0.6-5.3-0.6  c-1.6,0-3.4,0.2-5.3,0.6c-0.9,0.2-1.8,0-2.5-0.5c-0.6-0.4-1-1-1-1.7l-0.2-1.8v0C4,11.3,4,10.4,4.6,10z M17.4,27.3l-1.9,1.3  c-1.4,1-3.4,1-4.8,0l-1.9-1.3c-1.3-0.9-2.1-2.3-2.3-3.9l-0.4-4.3c0.3,0.1,0.7,0.1,1,0.1c0.4,0,0.9,0,1.3-0.1  c1.7-0.3,3.2-0.5,4.6-0.5c1.4,0,2.9,0.2,4.6,0.5c0.8,0.2,1.6,0.2,2.3,0.1l-0.4,4.3C19.5,25,18.7,26.4,17.4,27.3z"
            />
          </svg>
        </div> */}
        <div className="navbar-profile">
          <img
            className="img-fluid navbar-profile-sm"
            // src="https://1superapp.com/uploads/images/0f2fe74047de5a35650658a3aab710b1.jpeg"
            src={
              user_data.dp_url != null
                ? user_data.dp_url
                : require("../../assets/img/profile.png")
            }
          />
          <div className="fs-5 fw-bolder pt-2">{user_data.name}</div>
          <small className="text-gray fs-7 fw-bolder pt-1">
            @{user_data.username}
          </small>

          <div className="my-4 border-custom py-2">
            <h6 className="text-white fs-7 fw-bolder pt-2">
              {view_data.brand_name}
            </h6>
            <p className="text-whitesgray fs-7 fw-bolderpt-1 mb-0">
              {view_data.name}
            </p>
          </div>
          {/* <div className="sidebar-options dropdown d-sm-block d-md-none">
            <a href="/">
              <img src={require("../../assets/icon/svg/home.svg")} alt="" />
            </a>
            <button
              type="button"
              className="remove-after dropdown-toggle"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src={require("../../assets/icon/svg/bell.svg")} alt="" />
            </button>
            <a href="#">
              <img src={require("../../assets/icon/svg/log-out.svg")} alt="" />
            </a>
            <div
              className="sidebar-notification p-3 dropdown-menu"
              aria-labelledby="dropdownMenuButton1"
            >
              <div className="sidebar-notification-content">
                <a href="#" className="notification-text">
                  Nirmal Durai just sent a new comment!
                </a>
                <a href="#" className="notification-text">
                  Nirmal Durai just sent a new comment!
                </a>
                <a href="#" className="notification-text">
                  Nirmal Durai just sent a new comment!
                </a>
                <a href="#" className="notification-text">
                  Nirmal Durai just sent a new comment!
                </a>
                <a href="#" className="notification-text">
                  Nirmal Durai just sent a new comment!
                </a>
                <a href="#" className="notification-text">
                  Nirmal Durai just sent a new comment!
                </a>
                <a href="#" className="notification-text">
                  Nirmal Durai just sent a new comment!
                </a>
              </div>
            </div>
          </div> */}
        </div>
        <div className="sidebar-sticky">
          <ul>
            {menu_items.map((m_item, m_index) =>
              m_item.hasOwnProperty("children") ? (
                <li className="sidebar-dropdown" key={m_index}>
                  <a
                    className={
                      m_item.is_open
                        ? "sidebar-dropdown-btn active"
                        : "sidebar-dropdown-btn"
                    }
                    role="button"
                    onClick={() => {
                      dropdown_action(m_item, m_index);
                    }}
                  >
                    <img
                      src={require("../../assets/icon/svg/settings.svg")}
                      className="icon-img"
                    />{" "}
                    {m_item.name}
                    <i className="fas fa-chevron-down sidebar-dropdown-arrow"></i>
                  </a>
                  <div className="sidebar-dropdown-menu">
                    <ul>
                      {m_item.children.map((m_c_item, m_c_index) => (
                        <li key={m_c_index}>
                          <NavLink
                            className="link-loader"
                            activeclassname="link-active"
                            to={m_c_item.path}
                            onClick={() => {
                              // dropdown_close();
                              props.menu_click(false);
                            }}
                          >
                            <img src={m_c_item.img} className="icon-img" />{" "}
                            {m_c_item.name}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
              ) : (
                <li key={m_index}>
                  <NavLink
                    className="link-loader d-flex align-items-center"
                    activeclassname="link-active"
                    to={m_item.path}
                    onClick={() => {
                      dropdown_close();
                      props.menu_click(false);
                    }}
                  >
                    <img src={m_item.img} className="icon-img" />{" "}
                    <p className="mb-0 text-white">{m_item.name}</p>
                  </NavLink>
                </li>
              )
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
